import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from '../../import-step';
import { ColumnScrollService } from '../../column-scroll.service';

@Component({
    selector: 'formula-input-selection',
    templateUrl: './formula-input.component.html',
    styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class FormulaInputComponent extends BaseColumnSelectComponent {
    readonly step = ImportStep.Formula;
    projectId: string;
    columns: ColumnForSelection[];
    formula: string;
    outcomeName: string = '';

    loading = false;
    dataLoaded = false;
    refineFormula = false;

    constructor(private dataService: DataService, projectService: ProjectService, columnScrollService: ColumnScrollService){
        super(projectService, columnScrollService);
    }

    protected async loadDataInternal(): Promise<void> {
        const resp = await this.dataService.get<any>('columnSelection/formula/' + this.projectId);
        this.stepState = resp.stepState;
        this.formula = resp.formula;
        this.outcomeName = resp.outcomeName;
        this.columns = resp.columns;
        this.highlightMentionedFormulaComponents();
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    public columnClicked(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        this.addColumnToFormula(column);
    }

    private addColumnToFormula(column: ColumnForSelection): void {
        if (column.isSelected) {
            return;
        }
        let columnNameBracketed = '[' + column.name + ']';
        if (this.formula.indexOf(columnNameBracketed) >= 0) {
            return;
        }
        let str = '';
        if (this.formula) {
            str += ' * ';
        }
        this.formula += str + columnNameBracketed;
        this.highlightMentionedFormulaComponents();
    }

    formulaChanged() {
        this.highlightMentionedFormulaComponents();
    }

    async save() {
        if(this.loading) {
            return;
        }
        try {
            this.loading = true;
            const changesApplied = await this.dataService.post<boolean>('columnSelection/formula', {
                projectId: this.projectId,
                formula: this.formula,
            });
            this.refineFormula = false;
            this.finishStepSuccessfully(changesApplied);
        }
        catch (ex) {
            this.refineFormula = true;
        }
        finally {
            this.loading = false;
        }
    }

    private highlightMentionedFormulaComponents() {
        if (!this.formula) {
            return;
        }
        let formula = this.formula.toLowerCase();
        for (let i = 0;i < this.columns.length; ++i) {
            this.columns[i].isSelected = this.columns[i].mentionedInFormula = formula.indexOf('[' + this.columns[i].name.toLowerCase() + ']') >= 0
                                              || formula.indexOf('[@' + this.columns[i].name.toLowerCase() + ']') >= 0
                                              || formula.indexOf('[@[' + this.columns[i].name.toLowerCase() + ']]') >= 0;
        }
    }
    
    get componentsList(): string {
        if (!this.columns || !this.columns.length) {
            return '';
        }
        return this.columns.filter(c => c.isSelected).map(c => c.name).join(", ");;
    }
}
